import { render } from "./PlayStore.vue?vue&type=template&id=5bf3abf9"
import script from "./PlayStore.vue?vue&type=script&lang=js"
export * from "./PlayStore.vue?vue&type=script&lang=js"
script.render = render

export default script